import { BASE_URL, FEATURE_SETTINGS_ENDPOINT, SOMS_API_KEY } from "services/CONSTANTS";
import { BULK_UPDATE_MAX_CAP_FAILURE, BULK_UPDATE_MAX_CAP_REQUEST, BULK_UPDATE_MAX_CAP_RESET, BULK_UPDATE_MAX_CAP_SUCCESS } from "./action-type";
import { Patch } from "services/apiService";

export const bulkUpdateMaxCapAction = (payload) => {
    return (dispatch) => {
        dispatch(bulkUpdateMaxCapRequest());
        const apiUrl = `${BASE_URL}${FEATURE_SETTINGS_ENDPOINT}?apikey=${SOMS_API_KEY}`;
        const request = {
            url: apiUrl,
            params: payload,
        };
        Patch(request)
            .then((response) => {
                if (response.status === 200 || response.status === 204) {
                    dispatch(bulkUpdateMaxCapSuccess(response));
                } else {
                    dispatch(bulkUpdateMaxCapFailure(response));
                }
            })
            .catch((err) => {
                dispatch(bulkUpdateMaxCapFailure(err));
            });
    };
};

const bulkUpdateMaxCapRequest = () => ({
    type: BULK_UPDATE_MAX_CAP_REQUEST,
});

const bulkUpdateMaxCapSuccess = (response) => ({
    type: BULK_UPDATE_MAX_CAP_SUCCESS,
    bulkUpdateMaxCapResponse: response,
});

const bulkUpdateMaxCapFailure = (error) => ({
    type: BULK_UPDATE_MAX_CAP_FAILURE,
    bulkUpdateMaxCapResponse: error,
});

export const bulkUpdateMaxCapReset = () => ({
    type: BULK_UPDATE_MAX_CAP_RESET,
});
